import React from 'react';
import { Link } from 'react-router-dom';
import articles, { ISSUE } from '../data/eiffelArticles';
import useImagePreload from '../hooks/useImagePreload';
import BrandedLoader from '../components/BrandedLoader/BrandedLoader';
import '../theme/eiffelTheme.css';
import './TheEiffel.css';

export default function TheEiffel() {
  const ready = useImagePreload(ISSUE.coverImage);

  if (!ready) {
    return (
      <div className="eiffel-theme">
        <BrandedLoader fullscreen />
      </div>
    );
  }

  return (
    <div className="eiffel-theme">
      <div className="eiffel-nav-spacer" />
      <header className="eiffel-masthead">
        <div className="eiffel-masthead__rule" />
        <div className="eiffel-masthead__meta">
          <span>Vol. {ISSUE.volume}, No. {ISSUE.number}</span>
          <span>{ISSUE.quarter}</span>
          <span>{ISSUE.date}</span>
        </div>
        <h1 className="eiffel-masthead__title">The Eiffel</h1>
        <p className="eiffel-masthead__coverline">{ISSUE.coverLine}</p>
        <div className="eiffel-masthead__rule" />
      </header>

      <div className="eiffel-masthead__hero">
        <img src={ISSUE.coverImage} alt="" />
      </div>

      <section className="eiffel-archive container">
        <p className="eiffel-archive__intro">
          House TAU's own quarterly, digitised. New issues land here as they're
          published; this is the first.
        </p>

        <div className="eiffel-archive__grid">
          {articles.map((a) => (
            <Link key={a.slug} to={`/the-eiffel/${a.slug}`} className="eiffel-card">
              {a.heroImage && (
                <div className="eiffel-card__media">
                  <img src={a.heroImage.src} alt="" />
                </div>
              )}
              <div className="eiffel-card__meta">
                <span>{a.category}</span>
                <span>{a.date}</span>
              </div>
              <h3 className="eiffel-card__title">{a.title}</h3>
              <span className="eiffel-card__readtime">{a.readTime}</span>
            </Link>
          ))}
        </div>
      </section>

      <footer className="eiffel-footer">
        <span>@housetau on instagram</span>
      </footer>
    </div>
  );
}
